import { useEffect, useRef } from 'react';
import {
  servicioTiempoReal,
  type EventoTabla,
  type SuscripcionTiempoReal,
} from '../../data/realtime/ServicioTiempoReal';

type Payload = Parameters<Parameters<typeof servicioTiempoReal.suscribir>[1]>[0];

/**
 * Escucha los cambios de una tabla mientras el componente esté montado.
 *
 * La baja es automática al desmontar, que es la diferencia de fondo con la
 * versión anterior: allí cada pantalla tenía que acordarse de cerrar su canal
 * y olvidarlo dejaba suscripciones vivas consumiendo cuota.
 *
 * El manejador se guarda en una referencia, así que puede leer estado fresco
 * sin obligar a recrear la suscripción en cada renderizado.
 */
export function useTiempoReal(
  config: SuscripcionTiempoReal | null,
  manejador: (payload: Payload) => void,
): void {
  const refManejador = useRef(manejador);
  refManejador.current = manejador;

  const tabla = config?.tabla;
  const evento: EventoTabla | undefined = config?.evento;
  const filtro = config?.filtro;
  const esquema = config?.esquema;

  useEffect(() => {
    if (!tabla) return;

    return servicioTiempoReal.suscribir({ tabla, evento, filtro, esquema }, (payload) =>
      refManejador.current(payload),
    );
  }, [tabla, evento, filtro, esquema]);
}
